import React from "react";
import "./LoadingScreen.css"

export default function LoadingScreen() {
	return (
		<div className="loading-screen__main">
			<div class="loading-screen__boxes">
				<div class="box">
					<div></div>
					<div></div>
					<div></div>
					<div></div>
				</div>
				<div class="box">
					<div></div>
					<div></div>
					<div></div>
					<div></div>
				</div>
				<div class="box">
					<div></div>
					<div></div>
					<div></div>
					<div></div>
				</div>
				<div class="box">
					<div></div>
					<div></div>
					<div></div>
					<div></div>
				</div>
			</div>
		</div>
	);
}



// WEBPACK FOOTER //
// src/modules/screens/chatscreen/components/LoadingScreen/LoadingScreen.jsx